export enum EnumAuthQueryKeys {
  AUTHENTICATED_USER = 'AUTHENTICATED_USER',
  SCA_ACTION = 'SCA_ACTION',
  PKCE_SCA_ACTION = 'PKCE_SCA_ACTION',
  PKCE_SCA_USER_INFO = 'PKCE_SCA_USER_INFO',
  DECODED_PKCE_SESSION_TOKEN = 'DECODED_PKCE_SESSION_TOKEN',
  SCA_DEVICES = 'SCA_DEVICES',
  PUBLIC_SPONSORSHIP_VOUCHER = 'PUBLIC_SPONSORSHIP_VOUCHER',
}
